/**
 * This is the login page and is accessed by going to "/user/login".
 *
 * The page displays a form for the user to provide username and password and on submit will make a call to log
 * the user in.
 */
import JobiqoLogin, { getServerSideProps } from '~/jobiqo/pages/user/login';
export default JobiqoLogin;
export { getServerSideProps };
